import React from "react";

function initials(name) {
  if (!name) return "??";
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase() || first.toUpperCase();
}

// Deterministic pastel background from name
const PALETTE = ["#D4B3FF", "#CCFF00", "#FF9E80", "#A8E6FF", "#FFD6A5", "#B9FBC0", "#FFC6FF"];
function bgFor(name) {
  const s = (name || "?").split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  return PALETTE[s % PALETTE.length];
}

export default function Avatar({ name, picture, size = 40, online = false, showStatus = false, className = "" }) {
  const style = {
    width: size,
    height: size,
    background: picture ? "#eee" : bgFor(name),
  };

  return (
    <div className={`relative inline-block ${className}`}>
      <div
        className="rounded-full border-[2.5px] border-[#0A0A0A] overflow-hidden flex items-center justify-center font-black text-[#0A0A0A]"
        style={style}
        data-testid="avatar"
      >
        {picture ? (
          <img src={picture} alt={name} className="w-full h-full object-cover" />
        ) : (
          <span style={{ fontSize: size * 0.36 }}>{initials(name)}</span>
        )}
      </div>
      {showStatus && (
        <span
          className={`absolute -bottom-0.5 -right-0.5 block rounded-full border-[2px] border-[#0A0A0A] ${
            online ? "bg-[#CCFF00]" : "bg-[#555]"
          }`}
          style={{ width: size * 0.28, height: size * 0.28 }}
          data-testid="avatar-status"
        />
      )}
    </div>
  );
}
